import { OnlineStorage, PicturePack, PictureDataset, TextDataset } from "@tblabs/storage";
import { Collection } from "@tblabs/truffle";
import { UserProvider } from "./UserProvider";
import { ChatEntry, MessageChatEntry, PictureChatEntry } from "../Models/ChatEntry";
import { IChatView } from "./IChatView";
import { ChatEntryConverter } from "./ChatEntryConverter";


export class Chat implements IChatView
{
    public Messages = new Collection<ChatEntry>();
    private messageIndex = 0;
    private readonly picturesDataset: PictureDataset;
    private readonly textDataset: TextDataset<ChatEntry>;

    public get UserId(): string
    {
        return this._user.Id || "";
    }

    public get PicturesDataset(): PictureDataset
    {
        return this.picturesDataset;
    }

    constructor(private _storage: OnlineStorage, private _user: UserProvider, private chatId: string)
    {
        this.textDataset = this._storage.GetTextDataset("Chats", new ChatEntryConverter()) as TextDataset<ChatEntry>;

        this.picturesDataset = this._storage.GetPictureDataset("Pics", {
            KeepSource: false,
            Sizes: {
                "big": { ResizeToHeight: 1024 },
                "thumbnail": { ResizeToHeight: 256 }
            },
        });

        // let refreshCounter = 0;
        // let nextRefresh = 15;
        // if (0)
        // setInterval(async () =>
        // {
        //     if (refreshCounter > nextRefresh)
        //         {
        //             await this.Refresh();
        //             refreshCounter = 0;
        //             // if (nextRefresh < 60)
        //             //     nextRefresh += 10;
        //         }
        //         refreshCounter++;
        // }, 1000);
    }

    public EnableAutoRefresh(interval: number): void
    {
        setInterval(async () =>
        {
            await this.Refresh();
        }, interval);
    }

    public async Create(): Promise<void>
    {
        await this.textDataset.Create(this.chatId);
    }

    public async Load(): Promise<void>
    {
        try
        {
            console.log("Loading chat...", new Date().toISOString());

            const numberOfLastMessages = 100;
            const messages = await this.textDataset.Load(this.chatId, (-numberOfLastMessages));
            if (messages.length == 0)
            {
                console.log("No messages to load");
                return;
            }
            this.messageIndex = +messages[messages.length - 1].Id;

            this.Messages.Load(...messages);

            this.EnableAutoRefresh(15000);
        }
        catch (ex: any)
        {
            console.error(`Problem with chat: ${ex.message}`);
            throw new Error(`Błędny adres chatu`);
        }
    }

    public async Refresh(): Promise<void>
    { 
        try
        {
            console.log("Refreshing chat...", new Date().toISOString());

            const messages = await this.textDataset.Load(this.chatId, this.messageIndex);
            if (messages.length == 0)
            {
                console.log("No new messages");
                return;
            }
            this.messageIndex = +messages[messages.length - 1].Id;
            this.Messages.Add(...messages);
        }
        catch (ex: any)
        {
            console.error(`Problem with refreshing chat: ${ex.message}`);
            throw new Error(`Problem z odświeżaniem wiadomości ${ex.message}`);
        }
    }

    public async AddMessage(text: string): Promise<void>
    {
        this.messageIndex++;
        const entry = new MessageChatEntry(this.messageIndex.toString(), new Date().toISOString(), this.UserId, text);

        this.Messages.Add(entry);

        await this.textDataset.Append(this.chatId, entry);
    }

    public async AddPictures(pics: PicturePack[]): Promise<void>
    {
        this.messageIndex++;
        const entry = new PictureChatEntry(this.messageIndex.toString(), new Date().toISOString(), this.UserId, JSON.stringify(pics));

        this.Messages.Add(entry);

        await this.textDataset.Append(this.chatId, entry);
    }
}
